import React, { useEffect, useState } from 'react';
import { translate } from '../../Services/translation';
import SideMenu from '../SideMenu/SideMenu';
import Icon from '../Icon';

const ProductPageBuyGuideContainer = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [buyGuideContainerRef, setBuyGuideContainerRef] = useState<
    HTMLDivElement | undefined
  >();
  const [children, setChildren] = useState<Element[]>([]);

  useEffect(() => {
    if (!modalOpen) {
      setBuyGuideContainerRef(undefined);
    }
  }, [modalOpen]);

  useEffect(() => {
    const buyGuideElem = document.getElementById('buy-guide-content');
    setChildren(Array.from(buyGuideElem?.children ?? []));
  }, []);

  useEffect(() => {
    if (buyGuideContainerRef) {
      buyGuideContainerRef.innerHTML = '';
      for (var child of children) {
        buyGuideContainerRef.appendChild(child);
      }
    }
  }, [buyGuideContainerRef, children]);
  return (
    <>
      <div className="block">
        <button
          className="flex items-center"
          onClick={() => setModalOpen(!modalOpen)}
        >
          <Icon
            name="question-light"
            className="mr-1 h-5 w-5 text-gray-700"
          />
          <span className="text-sm font-normal uppercase tracking-wider underline">
            {translate('product-page.buy-guide-link')}
          </span>
        </button>
      </div>
      <SideMenu
        id="buyGuide"
        open={modalOpen}
        title={' '}
        onClosed={() => setModalOpen(false)}
        className={
          'm-2 !h-[calc(100%_-_1rem)] rounded md-down:w-[calc(100%_-_1rem)] [&_>div:first-child]:h-[52px] [&_>div]:!pl-0 [&_>div]:!pr-0'
        }
        useSideMenu={true}
      >
        <div className="pl-7 pr-7 lg:pl-[48px] lg:pr-[48px]">
          <h2 className="mb-6">{translate('buy-guide.title')}</h2>
          <div
            id="buy-guide-content"
            ref={(ref) => {
              if (ref) {
                setBuyGuideContainerRef(ref);
              }
            }}
          ></div>
        </div>
      </SideMenu>
    </>
  );
};

export default ProductPageBuyGuideContainer;
